export default "__VITE_ASSET__5GGqdQJn__"